"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TouchEnvironmentActivation = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
var Activation_1 = require("./Activation");
var TouchEnvironmentActivation = /*#__PURE__*/function (_Activation_1$Activat) {
  _inherits(TouchEnvironmentActivation, _Activation_1$Activat);
  var _super = _createSuper(TouchEnvironmentActivation);
  function TouchEnvironmentActivation(options) {
    var _this;
    _classCallCheck(this, TouchEnvironmentActivation);
    _this = _super.call(this, options);
    _this.initialElTop = 0;
    _this.currentElTop = 0;
    return _this;
  }
  _createClass(TouchEnvironmentActivation, [{
    key: "touchStarted",
    value: function touchStarted(event) {
      throw new Error('NotYetImplemented');
    }
  }, {
    key: "touchMoved",
    value: function touchMoved(event) {
      throw new Error('NotYetImplemented');
    }
  }, {
    key: "touchEnded",
    value: function touchEnded() {
      this.deactivate();
    }
  }, {
    key: "touchCanceled",
    value: function touchCanceled() {
      this.deactivate();
    }
  }]);
  return TouchEnvironmentActivation;
}(Activation_1.Activation);
exports.TouchEnvironmentActivation = TouchEnvironmentActivation;